import { ComplianceApi } from '../api/complianceApi'

export async function downloadDocument(jobId, filename) {
  try {
    const response = await ComplianceApi.downloadJobFile(jobId)
    const url = URL.createObjectURL(new Blob([response.data]))
    const a = document.createElement('a')
    a.href = url; a.download = filename; a.click()
    URL.revokeObjectURL(url)
  } catch (err) {
    const detail = await err?.response?.data?.text?.().then(t => JSON.parse(t)?.detail).catch(() => null)
    throw new Error(detail || err.message)
  }
}
